import { additionalPropertiesBySampleIdI18n } from './additional-properties-by-sample-id';
import { eventAttributesI18n } from './attributes';
import { fullFrameDetectionsWithSettingsI18n } from './full-frame-detections-with-settings';
import { eventDetailsGeneralInfoI18n } from './general-info';
import { eventDetailsGeolocationI18n } from './geolocation';
import { topMatchCardInfoI18n } from './top-match-card-info';
import { topMatchEventInfoI18n } from './top-match-event-info';
import { topMatchFaceInfoI18n } from './top-match-face-info';

export const ruRu = ({
  ...eventDetailsGeneralInfoI18n.ruRu,
  ...eventDetailsGeolocationI18n.ruRu,
  ...additionalPropertiesBySampleIdI18n.ruRu,
  ...eventAttributesI18n.ruRu,
  ...fullFrameDetectionsWithSettingsI18n.ruRu,
  ...topMatchCardInfoI18n.ruRu,
  ...topMatchFaceInfoI18n.ruRu,
  ...topMatchEventInfoI18n.ruRu,
}) as Record<string, unknown>;

export const en = ({
  ...eventDetailsGeneralInfoI18n.en,
  ...eventDetailsGeolocationI18n.en,
  ...additionalPropertiesBySampleIdI18n.en,
  ...eventAttributesI18n.en,
  ...fullFrameDetectionsWithSettingsI18n.en,
  ...topMatchCardInfoI18n.en,
  ...topMatchFaceInfoI18n.en,
  ...topMatchEventInfoI18n.en,
}) as Record<string, unknown>;

export const ptBr = ({
  ...eventDetailsGeneralInfoI18n.ptBr,
  ...eventDetailsGeolocationI18n.ptBr,
  ...additionalPropertiesBySampleIdI18n.ptBr,
  ...eventAttributesI18n.ptBr,
  ...fullFrameDetectionsWithSettingsI18n.ptBr,
  ...topMatchCardInfoI18n.ptBr,
  ...topMatchFaceInfoI18n.ptBr,
  ...topMatchEventInfoI18n.ptBr,
}) as Record<string, unknown>;

export const esEs = ({
  ...eventDetailsGeneralInfoI18n.esEs,
  ...eventDetailsGeolocationI18n.esEs,
  ...additionalPropertiesBySampleIdI18n.esEs,
  ...eventAttributesI18n.esEs,
  ...fullFrameDetectionsWithSettingsI18n.esEs,
  ...topMatchCardInfoI18n.esEs,
  ...topMatchFaceInfoI18n.esEs,
  ...topMatchEventInfoI18n.esEs,
}) as Record<string, unknown>;
